// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"41db923e","598":"d2dc339f","703":"ef0c8454"}[chunkId] + ".chunk.js";
};